import React from 'react';
import { Shuffle } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type {
  WorkflowNodeRenderStrategy,
  WorkflowNodeViewData,
} from '../types';
import { asRecord, readString } from '../../utils';

const {
  WorkflowNodeType,
  readMapperFields,
  readMapperOutputMode,
  readMapperRowKey,
} = PersistedWorkflow;

/** The mapped field names, so the card says what the step actually publishes. */
function summarize(node: WorkflowNodeViewData): string | undefined {
  const fields = readMapperFields(node.data);
  if (fields.length === 0) {
    return undefined;
  }
  if (readMapperOutputMode(node.data) === 'row') {
    const count = fields.length;
    return `${readMapperRowKey(node.data)}: list of ${count} value${
      count === 1 ? '' : 's'
    }`;
  }
  return fields.map((field) => field.key).join(', ');
}

export const mapperNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: WorkflowNodeType.Mapper,
  accent: 'control',
  badge: 'Mapper',
  getTitle: (node) => readString(asRecord(node.data), 'name') ?? 'Mapper',
  getDescription: () =>
    'Collect fields from any earlier step into one input for the next one',
  renderIcon: () => <Shuffle className="h-4 w-4" />,
  renderBody: (node) => {
    const summary = summarize(node);
    return (
      <Text.Caption className="text-muted-foreground block truncate">
        {summary ?? 'No fields mapped'}
      </Text.Caption>
    );
  },
};
